import { SkyMessageBar } from "@skypointcloud/skypoint-ui";
import { overLimitLine, type NotStartedRow } from "@/hooks/use-import-selected";

/**
 * The part of an "Import selected" that did not start (Session 11, P1): one line per row,
 * "{name}: {reason}", in a warning bar directly above the grid, where the control that caused it
 * remains (ux-s10 §3: inline, never a toast). Rows past the per-click cap are one closing line;
 * they stay selected for the next click. Dismissible; the next Import selected replaces it.
 * The started part is the page notice, not this bar.
 */
export function ImportSelectedResult({
  rows,
  overLimit = 0,
  onDismiss,
}: {
  rows: readonly NotStartedRow[];
  /** How many selected rows were past the cap and were not attempted. */
  overLimit?: number;
  onDismiss: () => void;
}) {
  if (rows.length === 0 && overLimit === 0) return null;
  return (
    <SkyMessageBar
      intent="warning"
      layout="multiline"
      testId="connections-import-result"
      title={`${rows.length + overLimit} not started:`}
      onDismiss={onDismiss}
      message={
        <ul className="flex flex-col gap-0.5">
          {rows.map((row) => (
            <li key={row.dataflowId} data-testid={`connections-import-result-${row.dataflowId}`}>
              {row.name}: {row.reason}
            </li>
          ))}
          {overLimit > 0 ? (
            <li data-testid="connections-import-result-over-limit">{overLimitLine(overLimit)}</li>
          ) : null}
        </ul>
      }
    />
  );
}
